<template>
    <div>

        <el-tree
                :data="data"
                :props="defaultProps"
                accordion
                node-key="id"
                :default-expanded-keys="showid"
                :highlight-current='highlighter'
                class="trees mrt10 video-tree"
                @node-click="handleNodeClick">
        </el-tree>
    </div>
</template>

<script>
    import * as API from "./api"

    import {mapActions} from "vuex";

    export default {
        name: "tabTree",
        data(){
            return{
                showid:[1100],//默认展开的树
                id:0,//部门id
                highlighter:true,//页面高度
                data:[],//树数据
                defaultProps: {
                    children: 'list',
                    label:'name'
                },

            }
        },

        mounted(){
            this.departTree()
            // this.uploadFile()
        },
        methods:{
            //点击树触发事件
            handleNodeClick(data) {
                this.$emit('getValue',data)
                if(data.hasOwnProperty('department')==false){
                    if(data.list.length==0){
                        this.departEmployee(data)
                    }
                }
                // this.id=data.id
                // this.$emit('applicationList')
            },

            ...mapActions(["getCurrentMenuId"]),
            //部门树
            async departTree() {
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                // console.log(this.i_kqtcid)
                let params = {
                    i_uid:sessionStorage.getItem("userid")

                }
                let res = await API.departTree(params);
                if (res.code == 1) {
                    this.data=res.data
                    // console.log(this.data)
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },

            //查询人员
            async departEmployee(data) {
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                // console.log(this.i_kqtcid)
                let params = {
                    id:this.id
                }
                let res = await API.departEmployee(params);
                if (res.code == 1) {
                    if(data.hasOwnProperty('department')==false){
                        if(data.list==0){
                            data.list=res.data
                        }
                    }
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
        }
    }
</script>

<style lang="scss" scoped>
    .mrt10{
        margin-top: 3px;
    }
    //实现滚动功能
    .video-tree {
        /*background-color: rgb(241,241,241);*/
        overflow-y: auto;
        max-height: calc(60vh);
        min-height: calc(30vh);
    }
</style>